import React from "react";
import {useTranslation} from "react-i18next";
import {Field, Form, Formik} from "formik";
import {CircularProgress} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {updateParameters} from "../../redux_slices/userParametersSlice";
import {checkPermission, getContextSilent} from "../../redux_slices/contextSlice";
import Swal from "sweetalert2";

const FormComponent = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const user = useSelector(state => state.userParameters.credential);
    const userParametersStatus = useSelector(state => state.userParameters.status);
    const canEditUsername = useSelector(state => checkPermission(state, `settings.viewMenuLink`));

    const onFormSubmit = async (values, {resetForm}) => {
        await dispatch(updateParameters({values})).then(() => {
            Swal.fire({icon: "success", text: t(`PROFILE.MESSAGE.BASIC_INFO.SUCCESS`)});
        });
        await dispatch(getContextSilent());
    };

    let content;

    if (userParametersStatus.type === "succeeded") {
        const profileInitialValues = {
            name: user?.name || "",
            surname: user?.surname || "",
            username: user?.username || "",
        };
        content = (
            <Formik initialValues={profileInitialValues} onSubmit={onFormSubmit}>
                <Form>
                    <div className={"row"}>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="name">{t("PROFILE.FIRSTNAME_LABEL")}</label>
                                <Field
                                    id="name"
                                    name="name"
                                    required
                                    placeholder={t("PROFILE.FIRSTNAME_PLACEHOLDER")}
                                    className="form-control form-control-solid h-auto py-5 px-6"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="surname">{t("PROFILE.SURNAME_LABEL")}</label>
                                <Field
                                    id="surname"
                                    name="surname"
                                    required
                                    placeholder={t("PROFILE.SURNAME_PLACEHOLDER")}
                                    className="form-control form-control-solid h-auto py-5 px-6"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="username">{t("PROFILE.EMAIL_LABEL")}</label>
                        <Field
                            id="username"
                            name="username"
                            type={"email"}
                            className="form-control form-control-solid h-auto py-5 px-6"
                            disabled={!canEditUsername}
                            placeholder={t("PROFILE.EMAIL_PLACEHOLDER")}
                        />
                    </div>
                    <div className="d-flex">
                        <button type="submit" className="btn btn-primary mx-auto">
                            {t("PROFILE.SAVE_BUTTON")}
                        </button>
                    </div>
                </Form>
            </Formik>
        );
    } else {
        content = (
            <div className={`d-flex align-items-center justify-content-center`}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <div className="card card-custom gutter-b shadow">
            <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray">
                <div className="card-title">{t("PROFILE.FORM_TITLE")}</div>
            </div>
            <div className="card-body position-relative min-h-180px">{content}</div>
        </div>
    );
};
export default FormComponent;
